








import Vue from 'vue';

export default Vue.extend({
  name: 'ItemSkeleton',
  computed: {
    isMobile(): boolean {
      return this.$store.getters.isMobile;
    },
  },
});
